import {Section} from "../grouping/Section";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, FormSelect, Row} from "react-bootstrap";
import {DataListView} from "../grouping/DataListView";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {SECTOR_EMPTY, useSectorMutations, useSectors} from "../../api/sectorsapi";
import {useCallback, useState} from "react";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {CustomEditor} from "../CustomEditor";
import {ButtonLoading} from "../ButtonLoading";
import {useAuthenticated} from "../../contexts/authenticationcontext";
import {MemberCoupling} from "../MemberCoupling";
import {useMembersDetailed} from "../../api/memberapi";

export function SectorOption(props) {
    const {title} = props;
    const {sectors} = useSectors();
    const {sectorControl} = useAuthenticated();
    const {membersDetailed} = useMembersDetailed();
    const membersDetailedSectorControlFiltered = sectorControl === 'ALL' ? membersDetailed
        :
        membersDetailed?.filter(m => m.sector === sectorControl);
    const sectorsDetailedSectorControlFiltered = sectorControl === 'ALL' ? sectors
        :
        sectors?.filter(s => s.sectorNaam === sectorControl);
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);

    return <Section title={title}>

        {sectorControl === 'ALL' ? <Col className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col> : ""}
        <DataListView title={'Sectorlijst'}
                      onOpenChange={setOpen}
                      onItemEditChange={setFileEditing}
                      dataArray={sectorsDetailedSectorControlFiltered ? sectorsDetailedSectorControlFiltered : []}
                      header={[{title: "Sector naam", fieldName: "sectorNaam"}, {
                          title: "Sector nummer",
                          fieldName: "sectorNummer"
                      }, {title: "Voorzitter naam", fieldName: "voorzitterNaam"}, {
                          title: "Voorzitter voornaam",
                          fieldName: "voorzitterVoornaam"
                      }, {title: "Secretaris naam", fieldName: "secretarisNaam"}, {
                          title: "Secretaris voornaam",
                          fieldName: "secretarisVoornaam"
                      },]}
                      searchHeaders={[{title: "Sector naam", fieldName: "sectorNaam"}, {
                          title: "Sector nummer",
                          fieldName: "sectorNummer"
                      }, {title: "Voorzitter naam", fieldName: "voorzitterNaam"}, {
                          title: "Voorzitter voornaam",
                          fieldName: "voorzitterVoornaam"
                      }, {title: "Secretaris naam", fieldName: "secretarisNaam"}, {
                          title: "Secretaris voornaam",
                          fieldName: "secretarisVoornaam"
                      },]}
        />

        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          members={membersDetailedSectorControlFiltered}
                                                          onOpenChanged={setOpen}/>}/>
    </Section>
}

function FileOptionModalContent(props) {
    const {fileEditing, onOpenChanged, setFileEditing, members} = props;
    const [isLoading, setIsLoading] = useState(false);
    const {createSector, editSector, deleteSector} = useSectorMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {
        ...SECTOR_EMPTY
    }, [])

    const {
        tempObject,
        setTempObject,
        onChange,
        onEditorChange,

    } = useForm(initialObjectInintializer)

    async function handleCreateSubmit(e) {
        e.preventDefault();
        const result = await createSector(tempObject);
        if (result) {
            onOpenChanged(false);
            setFileEditing(undefined);
        }
        setIsLoading(false);
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editSector(tempObject);
        if (result) {
            onOpenChanged(false);
            setFileEditing(undefined);
        }
        setIsLoading(false);
    }

    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Section className={'px-3'} title={fileEditing ? "Wijzig sector" : "Nieuwe sector"}>
            <Row className={'g-0 mb-2'}>
                <Col xs={'auto'}>
                    <LabelWithInput title={"Sector naam"}><FormControl value={tempObject.sectorNaam}
                                                                       onChange={(e) => onChange(e, 'sectorNaam')}></FormControl></LabelWithInput>
                </Col>
                <Col xs={'auto'}>
                    <LabelWithInput title={"Sector nummer"}><FormControl value={tempObject.sectorNummer}
                                                                         onChange={(e) => onChange(e, 'sectorNummer')}></FormControl></LabelWithInput>
                </Col>
                <Col xs={'auto'}>
                    <LabelWithInput title={"Rekening nr"}><FormControl value={tempObject.sectorRekeningNr}
                                                                       onChange={(e) => onChange(e, 'sectorRekeningNr')}></FormControl></LabelWithInput>
                </Col>
            </Row>
            <hr/>
            <Section className={"mb-2"}>
                <MemberCoupling editItem={editSector} onFileEditingChange={setFileEditing} members={members}
                                itemEditing={fileEditing} setTempObject={setTempObject}/>
                <hr/>
                <FormLabel className={'mt-3'}>Extra info</FormLabel>
                <CustomEditor initText={fileEditing ? fileEditing.extraInfo : ''} onEditorChange={onEditorChange}
                              fieldName={'extraInfo'} height={200}/>
            </Section>
            <div hidden={true} className={"p-2 border border-danger rounded-2 mb-2"}>
                <strong>Info: Alles in dit rood kader is verouderd. Voor uw voorzitter en secretaris te wijzigen, gelieve de bovenstaande functies te gebruiken
                    waar je je voorzitter, secretaris, pennings meester en raadsleden kunt selecteren.</strong>

                <Section title={'Voorzitter'} className={'g-0 mt-2 mb-2'}>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Naam"}><FormControl value={tempObject.voorzitterNaam}
                                                                        onChange={(e) => onChange(e, 'voorzitterNaam')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Voornaam"}><FormControl value={tempObject.voorzitterVoornaam}
                                                                            onChange={(e) => onChange(e, 'voorzitterVoornaam')}></FormControl></LabelWithInput>
                        </Col>
                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Straat"}><FormControl value={tempObject.voorzitterStraat}
                                                                          onChange={(e) => onChange(e, 'voorzitterStraat')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Nr"}><FormControl value={tempObject.voorzitterNr}
                                                                      onChange={(e) => onChange(e, 'voorzitterNr')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Bus"}><FormControl value={tempObject.voorzitterBus}
                                                                       onChange={(e) => onChange(e, 'voorzitterBus')}></FormControl></LabelWithInput>
                        </Col>
                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Gemeente"}><FormControl value={tempObject.voorzitterGemeente}
                                                                            onChange={(e) => onChange(e, 'voorzitterGemeente')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Postcode"}><FormControl value={tempObject.voorzitterPostcode}
                                                                            onChange={(e) => onChange(e, 'voorzitterPostcode')}></FormControl></LabelWithInput>
                        </Col>

                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Tel/Gsm"}><FormControl value={tempObject.voorzitterTelGsm}
                                                                           onChange={(e) => onChange(e, 'voorzitterTelGsm')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Email"}><FormControl value={tempObject.voorzitterEmail}
                                                                         onChange={(e) => onChange(e, 'voorzitterEmail')}></FormControl></LabelWithInput>
                        </Col>

                    </Row>

                </Section>
                <hr/>
                <Section title={'Secretaris'} className={'g-0 mt-2 mb-2'}>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Naam"}><FormControl value={tempObject.secretarisNaam}
                                                                        onChange={(e) => onChange(e, 'secretarisNaam')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Voornaam"}><FormControl value={tempObject.secretarisVoornaam}
                                                                            onChange={(e) => onChange(e, 'secretarisVoornaam')}></FormControl></LabelWithInput>
                        </Col>
                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Straat"}><FormControl value={tempObject.secretarisStraat}
                                                                          onChange={(e) => onChange(e, 'secretarisStraat')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Nr"}><FormControl value={tempObject.secretarisNr}
                                                                      onChange={(e) => onChange(e, 'secretarisNr')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Bus"}><FormControl value={tempObject.secretarisBus}
                                                                       onChange={(e) => onChange(e, 'secretarisBus')}></FormControl></LabelWithInput>
                        </Col>
                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Gemeente"}><FormControl value={tempObject.secretarisGemeente}
                                                                            onChange={(e) => onChange(e, 'secretarisGemeente')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Postcode"}><FormControl value={tempObject.secretarisPostcode}
                                                                            onChange={(e) => onChange(e, 'secretarisPostcode')}></FormControl></LabelWithInput>
                        </Col>

                    </Row>
                    <Row className={'g-0'}>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Tel/Gsm"}><FormControl value={tempObject.secretarisTelGsm}
                                                                           onChange={(e) => onChange(e, 'secretarisTelGsm')}></FormControl></LabelWithInput>
                        </Col>
                        <Col xs={'auto'}>
                            <LabelWithInput title={"Email"}><FormControl value={tempObject.secretarisEmail}
                                                                         onChange={(e) => onChange(e, 'secretarisEmail')}></FormControl></LabelWithInput>
                        </Col>
                    </Row>

                </Section>
            </div>

            <Section>
                <Col>

                </Col>
                <Col className={'text-end'}> <ButtonLoading className={'btn-primary'} isLoading={isLoading}
                                                            title={'Submit'}
                                                            onClick={(e) => {
                                                                setIsLoading(true);
                                                                fileEditing ? handleEditSubmit(e) : handleCreateSubmit(e)
                                                            }}/></Col>
            </Section>

        </Section>

    </ModalContentContainer>
}